import { AbsWorkerNotice, } from './AbsWorkerNotice';
export class WorkerNoticePost extends AbsWorkerNotice {
    createReqBody() {
        const data = {
            distributorId: this.reqBody.distributorId,
            title: this.reqBody.title,
            body: this.reqBody.body,
            noticePeriodType: this.reqBody.noticePeriodType,
            workerNoticeTargetType: this.reqBody.workerNoticeTargetType,
            workers: this.reqBody.workers,
        };
        if (data.noticePeriodType === 'SELECTED') {
            data.noticeStart = this.reqBody.noticeStart;
            data.noticeEnd = this.reqBody.noticeEnd;
        }
        if (this.reqBody.hubId !== 'ALL') {
            data.hubId = this.reqBody.hubId;
        }
        return data;
    }
}
